<template>
    <section class="form-fields-contact-to-add flex-column">
        <div
            v-if="!hasContacts && !disabled"
            class="alert alert-info flex-column flex-level ai-center pt-4 pb-3 mb-3 prelative"
        >
            <div
                v-if="load"
                class="primary-05-bkg loader-container pabsolute flex-level ai-center jc-center"
            >
                <span class="loader" />
            </div>
            <icon-svg icon-name="user" :width="34" :height="34" viewBox="0 0 34 34">
                <component :is="'icon-user'"></component>
            </icon-svg>
            <span class="gray-60 semi-bold lh-20 mt-2">{{ $l10n.__('Pas de contact lié') }}</span>
        </div>
        <!-- CONTACT : ALREADY ADDED -->
        <div v-if="!load">
            <form-fields-contacts-list
                mode="manual"
                :lightForm="lightForm"
                :currentList="contacts"
                @remove-contact="removeContact"
                @edit-contact="editContact"
                :suggestionMsg="addToListWording.added"
                :currentStore="currentStore"
                :options="options"
            />
            <!-- CONTACT : AUTO SUGGESTION -->
            <form-fields-contacts-list
                mode="auto"
                :currentList="suggestionContactsList"
                @edit-contact="editContact"
                :actionLabel="addToListWording.search"
                :currentStore="currentStore"
            />
        </div>
        <!-- ADD NEW CONTACT BTN -->
        <CompassButton
            :label="addToListWording.add"
            type="secondary"
            @click="addContact()"
            :disabled="disabled"
            ref="contactBtn"
            :data-bot="getDatabot('btn', currentStore, 'contact')"
        />
    </section>
</template>
<script>
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';
import FormFieldsContactsList from 'vcomponents/thirds/thirdscomponents/FormFieldsContactsList.vue';
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconUser from 'vcomponents/icons/IconUser.vue';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        FormFieldsContactsList,
        IconSvg,
        IconUser,
    },
    props: {
        currentStore: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        addToListWording: {
            type: Object,
            required: false,
        },
        goBackMsg: {
            type: String,
            required: false,
            default: '',
        },
        lightForm: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    mixins: [DataBotsFormsMixins],
    data() {
        return {
            options: { selected: true },
            requireCustomfields: false,
        };
    },
    created() {
        if (!!this.lightForm) {
            this.$store
                .dispatch(`${this.currentStore}/fetchMandatory`, 'contact')
                .then((mandatory) => {
                    this.requireCustomfields = mandatory;
                });
        }
    },
    computed: {
        load() {
            return this.$store.getters[`${this.currentStore}/getLoading`];
        },
        getContacts() {
            return this.$store.getters[`${this.currentStore}/getContacts`];
        },
        contacts() {
            let list = [];
            const contacts = this.getContacts;
            for (let i = 0; i < contacts.length; i++) {
                let contactData = { ...contacts[i].contactSettings };
                if (this.lightForm) {
                    contactData.customfields =
                        contacts[i].customfields?.length > 0 ? contacts[i].customfields : [];
                }
                list.push(contactData);
            }
            return list;
        },
        state() {
            return this.$store.getters[`${this.currentStore}/getState`];
        },
        suggestionContactsList() {
            return this.$store.getters[`${this.currentStore}/getSuggestionContactsList`];
        },
        hasContacts() {
            return !_.isNil(this.contacts) && this.contacts.length > 0;
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        isManual(mode) {
            return mode === 'manual';
        },
        /**
         * Redirect to contact form
         */
        addContact() {
            if (!this.lightForm) {
                this.toContactForm({
                    linkedForm: {
                        new: true,
                        name: this.currentStore,
                        state: this.state,
                        back: true,
                        backMsg: this.goBackMsg,
                    },
                });
            } else if (this.lightForm) {
                this.openPopUp('contact', { name: null }, null);
            }
        },

        /**
         * Open a popup throught call of open() from popupPanel.js
         */
        openPopUp(type, defaultValue, index, imported = false) {
            this.open({
                key: `popupThirdForm`,
                props: {
                    options: {
                        types: { type: type, subType: null },
                        index: index,
                        action: 'create',
                        imported: imported,
                    },
                    current: this.currentStore,
                    defaultValue: defaultValue,
                },
            });
        },

        /**
         * Create or modify contact in lists
         * if lightForm === true, disable router.push to contact form and open a popup instead.
         * also, if index === null, then add current contact to contact list without opening the popup
         * contact (object) : datas of new/current contact
         */
        editContact(contact) {
            if (this.lightForm) {
                if (_.isNil(contact.index) || contact.mode !== 'manual') {
                    if (this.requireCustomfields) {
                        this.openPopUp(
                            'contact',
                            { ...contact.settings, customfields: contact.settings.customfields },
                            contact.index,
                            true,
                        );
                    } else {
                        let newContact = {
                            contactSettings: contact.settings,
                            id: contact.settings.id,
                            customfields: contact.settings.customfields,
                            imported: true,
                        };
                        this.$store.commit(`${this.currentStore}/setContact`, newContact);
                        this.$store.dispatch(
                            `${this.currentStore}/removeSuggestionContact`,
                            contact.index,
                        );
                    }
                } else if (
                    !_.isNil(contact.settings?.id) &&
                    (_.isNil(contact.settings.customfields) ||
                        contact.settings.customfields.length <= 0)
                ) {
                    this.$store
                        .dispatch(
                            `${this.currentStore}/fetchContactCustomField`,
                            contact.settings.id,
                        )
                        .then((cfs) => {
                            this.openPopUp(
                                'contact',
                                { ...contact.settings, customfields: cfs },
                                contact.index,
                                false,
                            );
                        });
                } else {
                    this.openPopUp(
                        'contact',
                        { ...contact.settings, customfields: contact.settings.customfields },
                        contact.index,
                        false,
                    );
                }
            } else {
                let user = {};
                if (!_.isUndefined(contact)) {
                    if (contact.mode !== 'manual' && contact.settings) {
                        // Contact already exist from search company result
                        user = {
                            id: contact.settings.id,
                            contactSettings: {
                                forename: contact.settings.forename,
                                name: contact.settings.name,
                                role: contact.settings.role,
                            },
                        };
                    } else if (contact.mode === 'manual' && !_.isNil(contact.index)) {
                        // Contact was already added to the company
                        user = this.$store.getters[`${this.currentStore}/getContact`](
                            contact.index,
                        );
                    }
                    this.toContactForm({
                        linkedContact: user,
                        linkedForm: {
                            new: !this.isManual(contact.mode),
                            index: contact.index,
                            name: this.currentStore,
                            state: this.state,
                            back: true,
                            backMsg: this.goBackMsg,
                        },
                    });
                }
            }
        },

        removeContact(index) {
            this.$store.dispatch(`${this.currentStore}/removeContact`, index);
        },

        toContactForm(params) {
            //save state in session storage if user try to use back/history
            this.$emit('to-children-form', true);
            sessionStorage.setItem('to_contact_form_session_storage', JSON.stringify(params));

            this.$router.push({ name: 'contact.form', params: params });
        },
    },
    watch: {
        getContacts(list) {
            const thirdCreated = this.$store.getters[`${this.currentStore}/getThirdStatus`];
            let contacts = false;
            if (!thirdCreated && !!list) {
                contacts = list.length > 0;
            }
            if ((contacts && !!this.suggestionContactsList) || !!thirdCreated) {
                this.$store.commit(`${this.currentStore}/setLoading`, false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
.form-fields-contact-to-add {
    .loader-container {
        opacity: 0.92;
        top: -1%;
        height: 104px;
        width: 528px;
        border-radius: 4px;
    }
    .loader {
        position: relative !important;
        border: 2px solid $gray-100;
        border-bottom: 2px solid $gray-0;
        border-radius: 50%;
        background-color: $white;
        width: 20px;
        height: 20px;
        top: 0 !important;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>
